/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { styled, css } from 'fierry/react.old/styled';


const widthConfig = ({ width }) => width && css`
  width: ${width}rem;
`;


const heightConfig = ({ height }) => height && css`
  height: ${height}rem;
`;


export default styled.div`
  ${widthConfig}
  ${heightConfig}
`;
